import * as React from "react";
import { NoArgCallback } from "../../typings/utils";
import { ArrowIcon } from "../Icons/Icons";
import styles from "./ShowMore.module.css";

interface IProps {
  blurOnClick?: boolean;
  onClick: NoArgCallback;
}

export default function ShowMore({ blurOnClick = true, onClick }: IProps) {
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const handleClick: React.MouseEventHandler = (ev) => {
    ev.preventDefault();
    onClick();

    const node = buttonRef.current;
    if (node && blurOnClick) {
      node.blur();
    }
  };

  return (
    <div className={styles.root}>
      <button className={styles.button} type="button" ref={buttonRef} onClick={handleClick}>
        Show more results <ArrowIcon direction="down" width={12} height={12} />
      </button>
    </div>
  );
}
